import React from 'react';
import { useIntl } from 'react-intl';

type Props<T> = {
  item: {
    id: string;
    type: string;
    defaultMessage: string;
    field: keyof T;
    value?: string | string[] | number;
    className: string;
    error?: boolean;
    disabled?: boolean;
    min?: number;
    max?: number;
  };
  onChange: (field: keyof T, value: string) => void;
};

export const InputField = <T,>({ item, onChange }: Props<T>) => {
  const intl = useIntl();
  const placeholder = intl.formatMessage({
    id: item.id,
    defaultMessage: item.defaultMessage,
  });

  const setInputValue = (value: string) => {
    if (onChange) {
      onChange(item.field, value);
    }
  };

  return (
    <input
      type={item.type}
      className={item.className}
      onChange={(event) => setInputValue(event.target.value)}
      value={item.value}
      placeholder={placeholder}
      style={{ borderColor: item.error ? 'red' : '' }}
      disabled={item.disabled}
      min={item.min}
      max={item.max}
    />
  );
};
